<soq-page-content class="soq-page-success">
  <procure-expansion-panel label="Error">
    <p>The page you were looking for could not be found. Please verify if you are using the correct invitation link.</p>
  </procure-expansion-panel>
</soq-page-content>
